/** (1, "flight") → "1 flight", (2, "flight") → "2 flights". Regular plurals only: the noun just takes an "s". */
export const prettyCount = (count: number, noun: string): string => `${count} ${noun}${count === 1 ? '' : 's'}`;
